export const MENU = {
  MODEL: "Model",
  ASSET: "Asset",
  LAYER: "Layer",
  MY: "My",
  FAVORITES: "Favorites",
  SCRIPT: "Script",
  // SNIPPET: "Snippet",
};

export const ASSET_LIST_TYPE = {
  IMAGE: "image",
  LIST: "list",
  WIDE: "wide",
};

export const ASSET_TYPE = {
  MODEL: "MODEL",
  ASSET: "ASSET",
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  SOUND: "SOUND",
  MESH: "MESH",
  GUI: "GUI",
  CAMERA: "CAMERA",
  LIGHT: "LIGHT",
  EFFECT: "EFFECT",
  PARTICLEMAP: "PARTICLEMAP",
  SPAWN: "SPAWN",
  STARTING_POINT: "starting_point",
  PORTAL: "portal",
  AD_MODEL: "ADASSET",
  NOT_SUPPORTED: "NOT_SUPPORTED",
};

export const ASSET_KEYWORD_LIST = [
  {name: "Mesh", type: "IMAGE"},
  {name: "GUI", type: "IMAGE"},
  {name: "Effect", type: "IMAGE"},
  {name: "Spawn", type: "IMAGE"},
  {name: "Video", type: "WIDE"},
  {name: "AD Asset", type: "IMAGE"},
];

export const ASSET_PARAMS = {
  MODEL: {
    publicStatus: true,
    topCategory: ASSET_TYPE.MODEL,
  },

  IMAGE: {
    publicStatus: true,
    topCategory: ASSET_TYPE.IMAGE,
  },

  MESH: {
    publicStatus: true,
    midCategory: ASSET_TYPE.MESH,
  },

  GUI: {
    publicStatus: true,
    midCategory: ASSET_TYPE.GUI,
  },

  SPAWN: {
    publicStatus: true,
    midCategory: ASSET_TYPE.SPAWN,
  },

  EFFECT: {
    publicStatus: true,
    subCategory: ASSET_TYPE.PARTICLEMAP,
  },

  VIDEO: {
    publicStatus: true,
    topCategory: ASSET_TYPE.VIDEO,
  },

  ADASSET: {
    publicStatus: true,
    midCategory: ASSET_TYPE.AD_MODEL,
  },

  LIGHT: {
    publicStatus: true,
    midCategory: ASSET_TYPE.LIGHT,
  },

  SOUND: {
    publicStatus: true,
    topCategory: ASSET_TYPE.SOUND,
  },

  CAMERA: {
    publicStatus: true,
    midCategory: ASSET_TYPE.CAMERA,
  },
};

export const ASSET_GENRE = {
  VEHICLE: "VEHICLE",
  BUILDING: "BUILDING",
  STRUCTURE: "STRUCTURE",
  NATURE: "NATURE",
  FURNITURE: "FURNITURE",
  DECORATION: "DECORATION",
  MACHINE: "MACHINE",
  FOODS: "FOODS",
  GROUND: "GROUND",
};

export const ASSET_GENRE_TITLE = {
  [ASSET_GENRE.VEHICLE]: "Vehicle",
  [ASSET_GENRE.BUILDING]: "Building",
  [ASSET_GENRE.STRUCTURE]: "Structure",
  [ASSET_GENRE.NATURE]: "Nature",
  [ASSET_GENRE.FURNITURE]: "Furniture",
  [ASSET_GENRE.DECORATION]: "Decoration",
  [ASSET_GENRE.MACHINE]: "Machine",
  [ASSET_GENRE.FOODS]: "Foods",
  [ASSET_GENRE.GROUND]: "Ground",
};

export const MODEL_KEYWORLD_LIST = [
  {name: "Vehicle", type: ASSET_GENRE.VEHICLE},
  {name: "Building", type: ASSET_GENRE.BUILDING},
  {name: "Structure", type: ASSET_GENRE.STRUCTURE},
  {name: "Nature", type: ASSET_GENRE.NATURE},
  {name: "Furniture", type: ASSET_GENRE.FURNITURE},
  {name: "Decoration", type: ASSET_GENRE.DECORATION},
  {name: "Machine", type: ASSET_GENRE.MACHINE},
  {name: "Foods", type: ASSET_GENRE.FOODS},
  {name: "Ground", type: ASSET_GENRE.GROUND},
];

export const ASSET_LIST_TITLE = {
  [ASSET_TYPE.MODEL]: "Model",
  [ASSET_TYPE.MESH]: "Mesh",
  [ASSET_TYPE.GUI]: "GUI",
  [ASSET_TYPE.SPAWN]: "Spawn",
  [ASSET_TYPE.EFFECT]: "Effect",
  [ASSET_TYPE.SOUND]: "Sound",
  [ASSET_TYPE.VIDEO]: "Video",
  [ASSET_TYPE.LIGHT]: "Light",
  [ASSET_TYPE.AD_MODEL]: "Ad Asset",
};

export const ASSET_TYPE_LIST = [
  {
    name: ASSET_LIST_TITLE[ASSET_TYPE.MODEL],
    type: ASSET_TYPE.MODEL,
  },
  {name: ASSET_LIST_TITLE[ASSET_TYPE.MESH], type: ASSET_TYPE.MESH},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.LIGHT], type: ASSET_TYPE.LIGHT},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.SPAWN], type: ASSET_TYPE.SPAWN},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.GUI], type: ASSET_TYPE.GUI},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.EFFECT], type: ASSET_TYPE.EFFECT},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.SOUND], type: ASSET_TYPE.SOUND},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.VIDEO], type: ASSET_TYPE.VIDEO},
  {name: ASSET_LIST_TITLE[ASSET_TYPE.AD_MODEL], type: ASSET_TYPE.AD_MODEL},
];

export const ASSET_LIST_TYPE_BY_PROP = {
  [ASSET_TYPE.MODEL]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.MESH]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.IMAGE]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.GUI]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.SPAWN]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.EFFECT]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.SOUND]: ASSET_LIST_TYPE.LIST,
  [ASSET_TYPE.VIDEO]: ASSET_LIST_TYPE.WIDE,
  [ASSET_TYPE.LIGHT]: ASSET_LIST_TYPE.LIST,
  [ASSET_TYPE.AD_MODEL]: ASSET_LIST_TYPE.IMAGE,
};

export const MY_ASSET_LIST_TYPE_BY_PROP = {
  [ASSET_TYPE.MODEL]: ASSET_LIST_TYPE.LIST,
  [ASSET_TYPE.IMAGE]: ASSET_LIST_TYPE.IMAGE,
  [ASSET_TYPE.VIDEO]: ASSET_LIST_TYPE.WIDE,
  [ASSET_TYPE.SOUND]: ASSET_LIST_TYPE.LIST,
};

export const SEARCH_PARAMS = {
  TYPE: "type",
  TAB: "tab",
  SEARCH: "search",
};

export const ASSET_CATEGORY = {
  COIN: "coin",
  WEAPON: "weapon",
  HOUSE: "house",
  LAKE: "lake",
  VILLAGE: "village",
};

export const MY_ASSET_TAB = {
  ASSET: "asset",
  FAVORITES: "favorites",
};

export const MY_ASSET_TAB_LIST = [
  {name: "Asset", type: MY_ASSET_TAB.ASSET},
  {
    name: "Favorites",
    type: MY_ASSET_TAB.FAVORITES,
  },
];

export const genreList = [
  {name: "Coin", type: ASSET_CATEGORY.COIN},
  {name: "Weapon", type: ASSET_CATEGORY.WEAPON},
  {name: "House", type: ASSET_CATEGORY.HOUSE},
  {name: "Lake", type: ASSET_CATEGORY.LAKE},
  {name: "Village", type: ASSET_CATEGORY.VILLAGE},
];

export const MY_ASSET_TYPE_LIST = [
  {
    id: 0,
    title: "ID_MYASSET_TYPE_MODEL",
    type: ASSET_TYPE.MODEL,
  },
  {
    id: 1,
    title: "ID_MYASSET_TYPE_IMAGE",
    type: ASSET_TYPE.IMAGE,
  },
  {
    id: 2,
    title: "ID_ASSET_TYPE_VIDEO",
    type: ASSET_TYPE.VIDEO,
  },
  {
    id: 3,
    title: "ID_ASSET_TYPE_SOUND",
    type: ASSET_TYPE.SOUND,
  },
  {
    id: 4,
    title: "ID_ASSET_TYPE_MESH",
    type: ASSET_TYPE.MESH,
  },
  {
    id: 5,
    title: "ID_ASSET_TYPE_GUI",
    type: ASSET_TYPE.GUI,
  },
  {
    id: 6,
    title: "ID_ASSET_TYPE_LIGHT",
    type: ASSET_TYPE.LIGHT,
  },
  {
    id: 8,
    title: "ID_ASSET_TYPE_SPAWN",
    type: ASSET_TYPE.SPAWN,
  },
];

export const recommendSearchKeywords = [
  "halloween",
  "dessert",
  "city",
  "forest",
  // "dungeon",
  "medieval",
  "desert",
  "space",
  // "interior",
  // "tree",
  // "grass",
];
